import styled from "styled-components";
import { DbExames, DbExamesCompleto } from "./DadosExames";
import { useContext, useEffect, useState } from "react";
import { PossiveisRespostas } from "./PossiveisRespostas";
import { PageContext } from "../../Context/PageContext";
import { supabase } from "../../../supabaseClient";
import greenCheck from "./greenCheck.png"
import Thankyou from "../Thankyou/Thankyou";

function Questionario() {

    const [tamanhoQuestionario, setTamanhoQuestionario] = useState(DbExamesCompleto().length);
    const [exameAtual, setExameAtual] = useState(0);

    const [disbaledOpacity, setDisabledOpacity] = useState(.5);
    const [disbaledEvents, setDisabledEvents] = useState('none');

    const [enableRegisterButton, setEnableRegisterButton] = useState(["none",.5]);

    const [greenCheckStateList, setGreenCheckStateList] = useState([]);

    const {answerList, nome, email, profissao, setPage} = useContext(PageContext);

    let listaDeRespostasLocal = answerList;

    //Inicialização e atualização da lista de checks verdes das perguntas
    let greenCheckAnswerList = []

    for (let i = 0; i < 124; i++) {
        greenCheckAnswerList.push(<CheckedIcon check={"none"} />)
    }

    function updateGreenCheckList() {
        for (let i in greenCheckAnswerList) {
            if(listaDeRespostasLocal[i].includes(1)) {
                greenCheckAnswerList[i] = <CheckedIcon check={greenCheck} />;
            } else {
                greenCheckAnswerList[i] = <CheckedIcon check={"none"} />;
            }
        }

        setGreenCheckStateList(greenCheckAnswerList)

    }

    function atualizarExame(numeroExame) {

        setExameAtual(numeroExame)

    }

    function registerButtonEnableCheck() {

        for(let i in listaDeRespostasLocal) {
            if(listaDeRespostasLocal[i].includes(1)) {
                continue
            } else {
                setEnableRegisterButton(["none", .5]);
                return;
            }
        }

        setEnableRegisterButton(["auto", 1]);


    }

    async function postResponse() {

        const { data, error } = await supabase.from('volunters')
        .insert({ email: email, name: nome, area: profissao, answerstring: listaDeRespostasLocal.flat().join('')});

        setTimeout(() => {
            setPage(<Thankyou/>)
        }, 2000);
        // retorna as linhas inseridas (opcional, mas comum)
    }

    function enableNextButton() {

        if(listaDeRespostasLocal[exameAtual].includes(1)) {
            setDisabledOpacity(1);
            setDisabledEvents('auto');
        } else {
            setDisabledOpacity(.5);
            setDisabledEvents('none');
            }
    }

    useEffect(() => {

        enableNextButton()
        updateGreenCheckList()

        for(let i in PossiveisRespostas()) {

            let input = document.getElementById(`A${i}`);

            if(listaDeRespostasLocal[exameAtual][i] == 1) {
                input.checked = true;
            } else { 
                input.checked = false;
            }

        }

    },[exameAtual]);

    useEffect(() => {
        const handleKeyDown = (e) => {
        if (e.repeat) return; // Evita processar enquanto a tecla estiver segurada

        if (e.key === "ArrowLeft" || e.key === "<") {
         // Usamos a versão funcional do setState para evitar closures travadas
          setExameAtual((prev) => (prev > 0 ? prev - 1 : prev));
        } 
        else if (e.key === "ArrowRight" || e.key === ">") {
          setExameAtual((prev) => (prev < 123 ? prev + 1 : prev));
        }
        };

        document.addEventListener("keydown", handleKeyDown);

        // LIMPEZA (Crucial para não travar a aplicação)
            return () => {
        document.removeEventListener("keydown", handleKeyDown);
            };
    }, []); // Array vazio garante que o listener só seja criado no "mount"

    return(
        <MasterContainer>
            <MainContent>
            <Cabecalho>
                <span>Hemograma {exameAtual + 1} / {DbExamesCompleto().length} </span>
                {greenCheckStateList[exameAtual]}
            </Cabecalho>

            <PrimeiraSecao>
            <ColunaA>
                {Campos.slice(1,10).map(item => {
                    return(
                            <LinhaDeCampo>
                                <Campo>{item}:</Campo>
                                <Campo>{DbExames(exameAtual)[item]}</Campo>
                            </LinhaDeCampo>
                    )
                })}
            </ColunaA>

            <ColunaA>
                {Campos.slice(10,20).map(item => {
                    return(
                            <LinhaDeCampo>
                                <Campo>{item}:</Campo>
                                <Campo>{DbExames(exameAtual)[item]}</Campo>
                            </LinhaDeCampo>
                    )
                })}
            </ColunaA>
            </PrimeiraSecao>

            <SegundaSecao>
                <CampoPergunta>
                    <TextoNegrito>O que os dados apresentados acima sugerem para o quadro clínico deste exame?</TextoNegrito>
                    (Pode marcar mais de uma opção)
                </CampoPergunta>

                <CampoResposta>
                    { PossiveisRespostas().map(resposta => {
                        return(
                        <Resposta>
                            <InputBox 
                            onClick={(e) => {
                                if(e.target.checked) {
                                    listaDeRespostasLocal[exameAtual][PossiveisRespostas().indexOf(resposta)] = 1;}
                                else {
                                    listaDeRespostasLocal[exameAtual][PossiveisRespostas().indexOf(resposta)] = 0;}
                                
                                enableNextButton()
                                registerButtonEnableCheck();
                                //console.log(listaDeRespostasLocal[exameAtual])
                            }}
                            type="checkbox" 
                            id={`A${PossiveisRespostas().indexOf(resposta)}`}/>
                            <span> - {resposta}</span>
                        </Resposta>)})
                    }
                </CampoResposta>

                <ContainerBotoes>
                    <AnteriorBotao onClick={() => {
                        if(exameAtual + 1 > 1) {atualizarExame(exameAtual - 1)}
                        else {return;}}}>
                        &lt;
                    </AnteriorBotao>

                    <ProximoBotao
                    disbaledEvents={disbaledEvents}
                    disbaledOpacity={disbaledOpacity}
                    onClick={() => {
                        if(exameAtual + 1 < 124) {atualizarExame(exameAtual + 1)}
                        else {return;}}}>
                        &gt;
                    </ProximoBotao>
                </ContainerBotoes>

            </SegundaSecao>
        </MainContent>

        <HemogramaSelection>
            <span>{nome} - {profissao}</span>
            <span>{email}</span>
            <SelectionTitle>Hemogramas</SelectionTitle>
            <ListMaster>
                {
                DbExamesCompleto().map(item => {

                    return(
                        <ListItem
                        onClick={
                            () => atualizarExame(parseInt(DbExamesCompleto().indexOf(item)))
                        }
                        >Exame - {parseInt(DbExamesCompleto().indexOf(item))+1}

                            {greenCheckStateList[parseInt(DbExamesCompleto().indexOf(item))]} 
                        </ListItem>
                    )
                })
                }
            </ListMaster>
            <ConfirmaRespostaBotao
                pointerEvent={enableRegisterButton[0]}
                opacit={enableRegisterButton[1]}
                onClick = {() => postResponse()}>
                Registrar respostas
            </ConfirmaRespostaBotao>
        </HemogramaSelection>

        </MasterContainer>
    )
}

export default Questionario;

const MasterContainer = styled.div`
    display: flex;
    //border: solid;
    justify-content: center;
    align-items: start;
    margin-top: 10px;
    width: 950px;

`

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    margin-right: 0px;

`

const HemogramaSelection = styled.div`
    display: flex;
    flex-direction: column;
    //border: solid 1px;
    border-radius: 5px;
    justify-content: start;
    align-items: center;
    width: 200px;
    height: 650px;
`

const SelectionTitle = styled.span`
    font-size: 20pt;
    font-weight: bold;
    margin: 10px 0;
`

const ListMaster = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    //border: solid 1px;
    overflow-y: scroll;
    margin-bottom: 20px;
    

`
const ListItem = styled.div`
    display: flex;
    //flex-direction: column;
    justify-content: center;
    align-items: center;
    //border: solid 1px;
    padding: 2px 5px;
    width: 160px;
    transition: .3s ease-in-out;
    border-radius: 5px;
    font-size: 14pt;


    &:hover{ 
        cursor: pointer;
        background-color: rgba(69, 70, 71, 0.9);
        color: white;
    }

`

const CheckedIcon = styled.div`
    background-image: url(${props => props.check});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    height: 40px;
    width: 40px;
    margin-left: 10px;


`

const Cabecalho = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    font-weight: bold;
    font-size: 24pt;
    width: 800px;
    margin-bottom: 10px;
`

const PrimeiraSecao = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 1px;
    //font-weight: bold;
    border-radius: 5px;
    padding: 10px 0;
    //background-color: rgba(0,0,0,.7);
    //color: white;
    width: 800px;
`

const SegundaSecao = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    margin-top: 10px;
    font-size: 14pt;
    //border: solid;
    //font-weight: bold;
    width: 800px;
`

const CampoPergunta = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    //border: solid;
    //font-weight: bold;
    margin-top: 20px;
    width: 800px;

`

const TextoNegrito = styled.span`
    font-weight: bold;
`
const CampoResposta = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    flex-wrap: wrap;
    //flex-direction: column;
    //border: solid;
    //font-weight: bold;
    margin-top: 10px;
    width: 800px;

`

const ConfirmaRespostaBotao = styled.div`
    padding: 10px 10px;
    background-color: rgba(29, 125, 189, 0.9);
    color: white;
    font-weight:  bold;
    cursor: pointer;
    transition: .2s ease-in-out;
    border-radius: 5px;
    font-size: 11pt;
    opacity: ${props => props.opacit};
    pointer-events: ${props => props.pointerEvent};


    &:hover {
        //transform: translate(0px, -5px);
        //box-shadow: 0px 2px 2px black;
        scale: 1.2;
    }

    &:active {
        //transform: translate(0px, 0px);
        //box-shadow: 0px 0px 0px black;
        scale: 1.0;
        opacity: .7;
    }

`

const ContainerBotoes = styled.div`
    display: flex;

`
const AnteriorBotao = styled.div`
    padding: 10px 15px;
    background-color: rgba(29, 125, 189, 0.9);
    color: white;
    font-weight:  bold;
    cursor: pointer;
    transition: .2s ease-in-out;
    border-radius: 5px;
    font-size: 14pt;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;



    &:hover {
        //transform: translate(0px, -5px);
        //box-shadow: 0px 2px 2px black;
        scale: 1.1;
    }

    &:active {
        //transform: translate(0px, 0px);
        //box-shadow: 0px 0px 0px black;
        scale: 1.0;
        opacity: .7;
    }

`
const ProximoBotao = styled.div`
    padding: 10px 15px;
    background-color: rgba(29, 125, 189, 0.9);
    color: white;
    font-weight:  bold;
    cursor: pointer;
    transition: .2s ease-in-out;
    border-radius: 5px;
    font-size: 14pt;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.disbaledOpacity};
    pointer-events: ${props => props.disbaledEvents};


    &:hover {
        //transform: translate(0px, -5px);
        //box-shadow: 0px 2px 2px black;
        scale: 1.1;
    }

    &:active {
        //transform: translate(0px, 0px);
        //box-shadow: 0px 0px 0px black;
        scale: 1.0;
        opacity: .7;
    }

`

const Resposta = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    //font-weight: bold;
    width: 230px;
    margin: 5px 10px;
    transition: .3s ease-in-out;
    border-radius: 5px;
    padding: 5px;

    &:hover {
        background-color: rgba(29, 125, 189, 0.9);
        color: white;
    }
`

const InputBox = styled.input`
    background-color: black;
    cursor: pointer;
    width: 25px;
    height: 25px;
`

const LinhaDeCampo = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid;
    width: 360px;
    //font-weight: bold;
`

const Campo = styled.div`
    display: flex;
    padding: 5px 10px;
    align-items: center;
    justify-content: start;
    //border: solid 1px;
    width: 190px;
    font-size: 14pt;
    //font-weight: bold;
`

const ColunaA = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //border: solid;
    //font-weight: bold;
    flex-direction: column;
`

const Campos = [
    "Hemograma",
    "Idade",
    "sexo 0 ou 1",
    "Sexo",
    "Hemácias",
    "Hemoglobina",
    "Hematócrito",
    "Vol. Corp. Médio",
    "Hem. Corp. Média",
    "C. H. Corp. Média",
    "Leucócitos",
    "Basófilos",
    "Eosinófilos",
    "Mieloócitos",
    "Jovens",
    "Bastões",
    "Segmentados",
    "Linfócitos",
    "Monócitos"
]
